import {combineEpics, Epic} from 'redux-observable';
import {from, of} from 'rxjs';
import {
    switchMap,
    map,
    startWith,
    catchError,
    filter
} from 'rxjs/operators';
import {isOfType} from 'typesafe-actions';

import {
    CodeBlockActions,
    CodeBlockActionTypes,
    uploadCsvFailed,
    uploadCsvSuccess,
    uploadingCsv,
    uploadCsvProgress,
} from '../actions/codeBlockActions';

import {IState} from '../reducers';
import {
    uploadCsv,
} from '../../services/codeBlockApi';

const uploadCsvEpic: Epic<CodeBlockActions, CodeBlockActions, IState, any> = (
    action$: any,
    state$: any,
    { dispatch }: any
) =>
    action$.pipe(
        filter(isOfType(CodeBlockActionTypes.UPLOAD_CSV)),
        switchMap((action: any) => {
            const { blockUid, workspaceId, startTime, file } = action.payload;

            const onProgress = (progressEvent: ProgressEvent) => {
                let percent = 0;
                if (progressEvent.total > 0) {
                  percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                }
                dispatch(uploadCsvProgress(blockUid, percent));
            };

            return from(uploadCsv(blockUid, workspaceId, startTime, file, onProgress)).pipe(
                map((response: any) => uploadCsvSuccess(blockUid, response.result)),
                startWith(uploadingCsv(blockUid)),
                catchError((error: any) => {
                    const apiMessage = error?.response?.data?.message || error.message || "Unknown error";
                    return of(uploadCsvFailed(blockUid, apiMessage));
                })
            )
        }
        )
    );


export default combineEpics(
  uploadCsvEpic
);
